import apiClient from './apiClient';

const API_URL = '/provincias';

// Obtener todas las provincias
export const getProvincias = async () => {
    const response = await apiClient.get(API_URL);
    return response.data;
};

// Obtener una provincia específica por ID
export const getProvinciaPorId = async (id) => {
    const response = await apiClient.get(`${API_URL}/${id}`);
    return response.data;
};
